import { categories } from '@/mocks/categories';

const CATEGORY_CARDS = [
  {
    id: 1, name: 'Обувь', url: categories[0].url,
    imgSrc: 'https://readdy.ai/api/search-image?query=Trendy%20athletic%20sneakers%20on%20light%20sand%20colored%20textured%20surface%2C%20soft%20morning%20sunlight%2C%20minimalist%20product%20photography%2C%20clean%20modern%20aesthetic%2C%20fresh%20natural%20vibe&width=600&height=800&seq=cat-new-01&orientation=portrait',
    thumbSrc: 'https://readdy.ai/api/search-image?query=Single%20white%20sneaker%20closeup%20on%20light%20background%2C%20minimalist%20product%20detail%20shot%2C%20clean%20professional%20photography&width=120&height=120&seq=cat-thumb-01&orientation=squarish'
  },
  {
    id: 2, name: 'Худи / Свитеры', url: categories[1].url,
    imgSrc: 'https://readdy.ai/api/search-image?query=Cozy%20knit%20sweater%20folded%20on%20warm%20oatmeal%20colored%20textured%20throw%20blanket%2C%20soft%20indoor%20lighting%2C%20minimalist%20lifestyle%20photography%2C%20hygge%20aesthetic%2C%20warm%20comforting%20tones&width=600&height=800&seq=cat-new-02&orientation=portrait',
    thumbSrc: 'https://readdy.ai/api/search-image?query=Knit%20sweater%20texture%20closeup%20on%20neutral%20background%2C%20minimalist%20fabric%20detail%2C%20warm%20cozy%20photography&width=120&height=120&seq=cat-thumb-02&orientation=squarish'
  },
  {
    id: 3, name: 'Футболки', url: categories[2].url,
    imgSrc: 'https://readdy.ai/api/search-image?query=Three%20pastel%20colored%20cotton%20t-shirts%20neatly%20stacked%20on%20light%20mint%20green%20fabric%20surface%2C%20soft%20overhead%20lighting%2C%20minimalist%20fashion%20flat%20lay%2C%20clean%20fresh%20aesthetic&width=600&height=800&seq=cat-new-03&orientation=portrait',
    thumbSrc: 'https://readdy.ai/api/search-image?query=Folded%20pastel%20t-shirt%20closeup%20on%20light%20surface%2C%20minimalist%20fashion%20detail%2C%20clean%20soft%20photography&width=120&height=120&seq=cat-thumb-03&orientation=squarish'
  },
  {
    id: 4, name: 'Куртки', url: categories[3].url,
    imgSrc: 'https://readdy.ai/api/search-image?query=Stylish%20bomber%20jacket%20draped%20over%20modern%20chair%20in%20bright%20airy%20room%2C%20soft%20natural%20window%20light%2C%20minimalist%20fashion%20editorial%2C%20light%20gray%20walls%2C%20clean%20contemporary%20interior&width=600&height=800&seq=cat-new-04&orientation=portrait',
    thumbSrc: 'https://readdy.ai/api/search-image?query=Jacket%20collar%20detail%20closeup%20on%20light%20background%2C%20minimalist%20fashion%20detail%2C%20clean%20editorial%20photography&width=120&height=120&seq=cat-thumb-04&orientation=squarish'
  },
  {
    id: 5, name: 'Брюки / Шорты', url: categories[4].url,
    imgSrc: 'https://readdy.ai/api/search-image?query=Tailored%20linen%20trousers%20elegantly%20laid%20flat%20on%20warm%20caramel%20wooden%20floor%2C%20soft%20side%20lighting%2C%20minimalist%20fashion%20photography%2C%20natural%20textures%2C%20clean%20composition&width=600&height=800&seq=cat-new-05&orientation=portrait',
    thumbSrc: 'https://readdy.ai/api/search-image?query=Linen%20pants%20fabric%20detail%20closeup%2C%20minimalist%20texture%20photography%2C%20warm%20natural%20tones&width=120&height=120&seq=cat-thumb-05&orientation=squarish'
  },
  {
    id: 6, name: 'Головные уборы', url: categories[5].url,
    imgSrc: 'https://readdy.ai/api/search-image?query=Stylish%20baseball%20cap%20and%20wool%20beanie%20on%20soft%20dusty%20rose%20colored%20linen%20background%2C%20minimalist%20accessories%20flat%20lay%2C%20soft%20diffused%20light%2C%20clean%20modern%20aesthetic&width=600&height=800&seq=cat-new-06&orientation=portrait',
    thumbSrc: 'https://readdy.ai/api/search-image?query=Baseball%20cap%20closeup%20on%20soft%20colored%20background%2C%20minimalist%20accessory%20detail%2C%20clean%20photography&width=120&height=120&seq=cat-thumb-06&orientation=squarish'
  },
  {
    id: 7, name: 'Комплекты', url: categories[6].url,
    imgSrc: 'https://readdy.ai/api/search-image?query=Coordinated%20matching%20outfit%20set%20displayed%20on%20pale%20linen%20bed%20sheet%2C%20soft%20morning%20light%20from%20window%2C%20minimalist%20fashion%20editorial%2C%20clean%20coordinated%20aesthetic%2C%20relaxed%20mood&width=600&height=800&seq=cat-new-07&orientation=portrait',
    thumbSrc: 'https://readdy.ai/api/search-image?query=Matching%20clothing%20set%20folded%20detail%2C%20minimalist%20fashion%20photography%2C%20clean%20composition&width=120&height=120&seq=cat-thumb-07&orientation=squarish'
  },
  {
    id: 8, name: 'Нижнее бельё', url: categories[7].url,
    imgSrc: 'https://readdy.ai/api/search-image?query=Soft%20organic%20cotton%20underwear%20neatly%20arranged%20on%20light%20lavender%20gray%20fabric%2C%20soft%20diffused%20studio%20lighting%2C%20minimalist%20product%20photography%2C%20clean%20delicate%20composition&width=600&height=800&seq=cat-new-08&orientation=portrait',
    thumbSrc: 'https://readdy.ai/api/search-image?query=Soft%20cotton%20fabric%20detail%20closeup%20on%20light%20background%2C%20minimalist%20texture%20photography&width=120&height=120&seq=cat-thumb-08&orientation=squarish'
  },
  {
    id: 9, name: 'Джерси', url: categories[8].url,
    imgSrc: 'https://readdy.ai/api/search-image?query=Sports%20jersey%20displayed%20against%20warm%20ivory%20textured%20wall%2C%20soft%20gym%20lighting%2C%20athletic%20product%20photography%2C%20clean%20sporty%20aesthetic%2C%20dynamic%20yet%20minimal%20composition&width=600&height=800&seq=cat-new-09&orientation=portrait',
    thumbSrc: 'https://readdy.ai/api/search-image?query=Sports%20jersey%20fabric%20detail%20closeup%2C%20minimalist%20athletic%20photography%2C%20clean%20texture%20shot&width=120&height=120&seq=cat-thumb-09&orientation=squarish'
  },
  {
    id: 10, name: 'Аксессуары', url: categories[9].url,
    imgSrc: 'https://readdy.ai/api/search-image?query=Elegant%20watch%20bracelet%20and%20sunglasses%20artfully%20arranged%20on%20dark%20slate%20gray%20surface%2C%20dramatic%20side%20lighting%2C%20luxury%20accessories%20flat%20lay%2C%20editorial%20fashion%20photography&width=600&height=800&seq=cat-new-10&orientation=portrait',
    thumbSrc: 'https://readdy.ai/api/search-image?query=Watch%20closeup%20detail%20on%20dark%20surface%2C%20minimalist%20luxury%20accessory%20photography&width=120&height=120&seq=cat-thumb-10&orientation=squarish'
  },
  {
    id: 11, name: 'Сумки', url: categories[10].url,
    imgSrc: 'https://readdy.ai/api/search-image?query=Stylish%20crossbody%20bag%20on%20light%20moss%20green%20velvet%20surface%2C%20soft%20natural%20sunlight%20through%20leaves%2C%20minimalist%20fashion%20photography%2C%20organic%20fresh%20aesthetic&width=600&height=800&seq=cat-new-11&orientation=portrait',
    thumbSrc: 'https://readdy.ai/api/search-image?query=Leather%20bag%20texture%20closeup%20detail%2C%20minimalist%20fashion%20photography%2C%20clean%20composition&width=120&height=120&seq=cat-thumb-11&orientation=squarish'
  },
  {
    id: 12, name: 'Ремни', url: categories[11].url,
    imgSrc: 'https://readdy.ai/api/search-image?query=Premium%20leather%20belt%20coiled%20elegantly%20on%20warm%20sand%20colored%20textured%20paper%2C%20soft%20studio%20lighting%2C%20minimalist%20product%20photography%2C%20clean%20luxurious%20composition&width=600&height=800&seq=cat-new-12&orientation=portrait',
    thumbSrc: 'https://readdy.ai/api/search-image?query=Leather%20belt%20buckle%20closeup%20detail%2C%20minimalist%20product%20photography%2C%20clean%20professional%20shot&width=120&height=120&seq=cat-thumb-12&orientation=squarish'
  },
  {
    id: 13, name: 'Парфюмерия', url: categories[12].url,
    imgSrc: 'https://readdy.ai/api/search-image?query=Two%20elegant%20perfume%20bottles%20on%20soft%20peach%20colored%20silk%20fabric%20with%20flower%20petals%2C%20warm%20golden%20hour%20lighting%2C%20luxury%20beauty%20photography%2C%20romantic%20soft%20composition&width=600&height=800&seq=cat-new-13&orientation=portrait',
    thumbSrc: 'https://readdy.ai/api/search-image?query=Perfume%20bottle%20closeup%20detail%20on%20soft%20fabric%2C%20minimalist%20beauty%20photography%2C%20elegant%20composition&width=120&height=120&seq=cat-thumb-13&orientation=squarish'
  },
  {
    id: 14, name: 'Разное', url: categories[13].url,
    imgSrc: 'https://readdy.ai/api/search-image?query=Assorted%20fashion%20accessories%20and%20small%20items%20creatively%20arranged%20on%20warm%20clay%20colored%20textured%20surface%2C%20soft%20overhead%20lighting%2C%20eclectic%20minimalist%20flat%20lay&width=600&height=800&seq=cat-new-14&orientation=portrait',
    thumbSrc: 'https://readdy.ai/api/search-image?query=Mixed%20fashion%20accessories%20closeup%20flat%20lay%2C%20minimalist%20eclectic%20photography&width=120&height=120&seq=cat-thumb-14&orientation=squarish'
  },
];

const firstFour = CATEGORY_CARDS.slice(0, 4);
const remaining = CATEGORY_CARDS.slice(4);

export default function CategoryGrid() {
  return (
    <section className="py-24 md:py-32 bg-background-50">
      <div className="px-6 md:px-10 max-w-[1400px] mx-auto">
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-14 gap-4">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground-950">
            14 категорий из Китая
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-sm">
            Выберите категорию и перейдите к покупкам
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-4 gap-4">
          <div className="lg:col-span-2 bg-foreground-950 rounded-2xl p-6 md:p-8 flex flex-col justify-between">
            <div>
              <p className="text-xs text-white/50 uppercase tracking-widest mb-6 whitespace-nowrap">Популярные категории</p>
              <div className="space-y-0">
                {firstFour.map((cat) => (
                  <a
                    key={cat.id}
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="flex items-center gap-4 py-3 text-lg md:text-xl text-white hover:text-primary-300 transition-colors border-b border-white/10 cursor-pointer group"
                  >
                    <div className="w-12 h-12 rounded-lg overflow-hidden flex-shrink-0 bg-white/10">
                      <img
                        src={cat.thumbSrc}
                        alt={cat.name}
                        className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                        loading="lazy"
                      />
                    </div>
                    <span className="whitespace-nowrap">{cat.name}</span>
                  </a>
                ))}
              </div>
            </div>
            <a
              href={categories[0].url}
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 mt-8 text-sm text-white/60 hover:text-white transition-colors cursor-pointer whitespace-nowrap"
            >
              <span>Смотреть все категории</span>
              <i className="ri-arrow-right-line text-sm w-4 h-4 flex items-center justify-center"></i>
            </a>
          </div>

          <div className="lg:col-span-2 relative rounded-2xl overflow-hidden">
            <div className="aspect-[16/10] w-full">
              <img
                src="https://readdy.ai/api/search-image?query=Stylish%20athletic%20sneakers%20displayed%20on%20light%20sand%20dune%20texture%20with%20warm%20sunset%20golden%20lighting%2C%20minimalist%20outdoor%20product%20photography%2C%20clean%20modern%20aesthetic%2C%20soft%20shadows%2C%20editorial%20adventure%20style&width=1200&height=750&seq=cat-feat-new&orientation=landscape"
                alt="Популярное — Обувь"
                title="Популярные товары — yoybuy spreadsheet"
                className="w-full h-full object-cover object-top"
                loading="lazy"
              />
            </div>
            <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent"></div>
            <div className="absolute top-4 left-4 bg-foreground-950/60 backdrop-blur-sm text-white text-xs font-medium px-3 py-1.5 rounded-full whitespace-nowrap">
              Обувь
            </div>
            <div className="absolute bottom-6 left-6">
              <span className="text-white text-xl md:text-2xl font-heading font-semibold whitespace-nowrap">Популярное</span>
            </div>
            <a
              href={categories[0].url}
              target="_blank"
              rel="noopener nofollow"
              className="absolute inset-0 cursor-pointer"
              aria-label="Перейти к категории Обувь"
            ></a>
          </div>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3 md:gap-4 mt-4">
          {remaining.map((cat) => (
            <a
              key={cat.id}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group relative rounded-xl overflow-hidden cursor-pointer"
            >
              <div className="aspect-[3/4] w-full">
                <img
                  src={cat.imgSrc}
                  alt={cat.name}
                  title={`${cat.name} — yoybuy spreadsheet`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/10 to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-3 md:p-4">
                <span className="text-white text-sm md:text-base font-medium whitespace-nowrap">{cat.name}</span>
                <i className="ri-arrow-right-up-line text-white/70 text-sm ml-1 w-3 h-3 inline-flex items-center justify-center"></i>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}